import React, { useEffect } from 'react';
import { useParams, useNavigate, Outlet } from 'react-router-dom';
import Navigation from '@/shared/components/Navigation';
import ToastContainer from '@/shared/components/ToastContainer';
import { useAuthContext } from '@/modules/auth/ui/AuthProvider';
import { useToast } from '@/hooks/useToast';
import { AdminAppProvider } from '@/modules/admin/context/AdminAppContext';
import AdminAppLayout from '@/modules/admin/components/AdminAppLayout';
import { ADMIN_EMAILS } from '../../../../shared/config/admins.js';
import { useAdminApp } from '@/hooks/queries';

export default function AdminAppPageWrapper() {
  const { appId } = useParams();
  const navigate = useNavigate();
  const { user, authFetch } = useAuthContext();
  const { showToast, toasts, hideToast } = useToast();

  // Use query hooks for data fetching
  const { data: app, isLoading: appLoading, error: appError } = useAdminApp(appId);

  const loading = appLoading;

  useEffect(() => {
    // Check if user is admin
    if (!ADMIN_EMAILS.includes(user?.email)) {
      showToast('Access denied. Admin only.', 'error');
      navigate('/admin-portal');
      return;
    }
  }, [user?.email]);

  useEffect(() => {
    if (appError) {
      showToast('Failed to load app', 'error');
      navigate('/admin-portal/apps');
    }
  }, [appError]);

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50">
        <Navigation />
        <div className="flex items-center justify-center h-96">
          <div className="text-center">
            <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-zapt-purple mb-4"></div>
            <p className="text-gray-600">Loading app...</p>
          </div>
        </div>
      </div>
    );
  }

  if (!app) {
    return null;
  }

  return (
    <AdminAppProvider
      initialApp={app}
      authFetch={authFetch}
      showToast={showToast}
      navigate={navigate}
    >
      <AdminAppLayout toasts={toasts} onCloseToast={hideToast}>
        <Outlet />
      </AdminAppLayout>
    </AdminAppProvider>
  );
}

